import { useState, useEffect } from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_2e63d1ea-98d8-49eb-bd51-d5bb765ca1d9/artifacts/q0d6l1en_Logo%20gro%C3%9F%20wei%C3%9F%20mit%20Rahmen%20%281%29.png";

export default function IntroAnimation() {
  const [phase, setPhase] = useState('init');

  useEffect(() => {
    if (sessionStorage.getItem('jf-nexus-intro')) {
      setPhase('done');
      return;
    }
    const timers = [
      setTimeout(() => setPhase('logo'), 100),
      setTimeout(() => setPhase('bar'), 800),
      setTimeout(() => setPhase('text'), 1600),
      setTimeout(() => setPhase('exit'), 2600),
      setTimeout(() => {
        setPhase('done');
        sessionStorage.setItem('jf-nexus-intro', '1');
      }, 3400),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  if (phase === 'done') return null;

  return (
    <div
      data-testid="intro-animation"
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#FAFAFA] transition-all duration-700 ease-out ${
        phase === 'exit' ? 'opacity-0' : 'opacity-100'
      }`}
      style={{ pointerEvents: phase === 'exit' ? 'none' : 'auto' }}
    >
      {/* Soft gradient blobs */}
      <div className="absolute top-1/3 left-1/3 w-80 h-80 bg-purple-300/15 rounded-full blur-[100px]" />
      <div className="absolute bottom-1/3 right-1/3 w-80 h-80 bg-pink-300/15 rounded-full blur-[100px]" />

      {/* Logo */}
      <img
        src={LOGO_URL}
        alt="JF-NEXUS"
        className={`w-28 h-28 sm:w-36 sm:h-36 object-contain transition-all duration-700 ease-out ${
          phase === 'init' ? 'opacity-0 scale-90' : 'opacity-100 scale-100'
        }`}
      />

      {/* Progress bar */}
      <div className="mt-8 w-36 h-[2px] rounded-full bg-slate-200/60 overflow-hidden">
        <div
          className={`h-full rounded-full bg-gradient-to-r from-indigo-600 via-purple-500 to-pink-500 transition-all ease-out ${
            phase === 'init' ? 'w-0 duration-0'
              : phase === 'logo' ? 'w-1/3 duration-700'
              : phase === 'bar' ? 'w-2/3 duration-700'
              : 'w-full duration-500'
          }`}
        />
      </div>

      {/* Tagline */}
      <p
        className={`mt-6 text-sm text-slate-400 font-['Outfit'] tracking-wide transition-all duration-500 ${
          phase === 'text' || phase === 'exit' ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
        }`}
      >
        Ihre digitale Zukunft beginnt.
      </p>
    </div>
  );
}
